module.exports = __webpack_public_path__ + "static/media/DSC_0323.be9f11ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0323.jpg
// module id = 596
// module chunks = 0